<template>
  <div class="pxp-cta-3 tw-py-24" :style="`background-color: var(--c-${vars.backgroundColor});`">
    <div class="container">
      <div class="tw-w-full">
        <div class="tw-mb-16 tw-flex tw-flex-col tw-items-center tw-self-center tw-text-center">
          <div v-if="vars.titleHtml" v-html="vars.titleHtml"></div>
        </div>
        <div class="tw-w-full !tw-text-white">
          <Swiper
            @slideChange="onSlideChange"
            @swiper="onSwiper"
            :pagination="false"
            :centered-slides="true"
            :center-insufficient-slides="true"
            :space-between="15"
            effect="fade"
            :loop="true"
            :clickable="true"
            :breakpoints="{
              320: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              640: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 30,
              },
              1536: {
                slidesPerView: 7,
                spaceBetween: 40,
              },
            }"
            class="social-swiper tw-self-star tw-w-full"
          >
            <SwiperSlide v-for="(post, index) in instagram_posts?.content_list" :key="post.id || index">
              <div
                v-if="post.is_deleted === false && post.is_hidden === false"
                @click="openPopup(post, true)"
                class="no-hover shine-effect tw-group tw-relative tw-basis-1/3 tw-overflow-hidden tw-transition-all tw-duration-500 hover:tw-cursor-pointer"
              >
                <LibraryImage
                  :w-ratio="9"
                  :h-ratio="16"
                  :src="post.thumbnail_url"
                  style="border-radius: var(--rounded)"
                />

                <video
                  v-if="post.media_type === 'VIDEO'"
                  :src="post.media_url"
                  class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-100"
                  style="border-radius: var(--rounded)"
                  muted
                  loop
                  autoplay
                  playsinline
                ></video>

                <div
                  class="shine tw-absolute tw-inset-0 tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-30"
                  style="border-radius: var(--rounded)"
                ></div>
              </div>
            </SwiperSlide>
          </Swiper>
          <div class="tw-mt-10">
            <LibrarySliderPagination
              :swiper="swiper"
              variant="v6"
              :can-paginate-back="canPaginateBack"
              :can-paginate-next="canPaginateNext"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import Popup from '~/components/common/popup/Popup.vue';

export default defineNuxtComponent({
  components: { Popup },

  mixins: [ComponentMixin],

  data() {
    return {
      selectedPost: null,
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      popupConfig: {
        isActive: false,
      },
      isVisible: false,
      instagram_posts: null,
    };
  },

  computed: {
    displayPosts() {
      // Use Instagram posts if available, otherwise use dummy posts
      const instagramPosts = this.instagram_posts?.content_list;
      return instagramPosts && instagramPosts.length > 0 ? instagramPosts : this.dummyPosts;
    },
  },

  methods: {
    openPopup(post = null, value = false) {
      if (post) {
        this.selectedPost = post;
        this.popupConfig.isActive = value;
      }
    },

    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (this.variant === 'v1') {
        if (!this.swiper) return;
        const isAtStart = this.swiper.isBeginning;
        const isAtEnd = this.swiper.isEnd;
        if (isAtStart) this.canPaginateBack = false;
        else this.canPaginateBack = true;
        if (isAtEnd) this.canPaginateNext = false;
        else this.canPaginateNext = true;
      } else if (this.variant === 'v2') {
        if (!this.swiper) return;
        this.canPaginateBack = true;
        this.canPaginateNext = true;
      }
    },
  },
  created() {
    // Try to parse Instagram posts, but don't fail if not available
    try {
      this.instagram_posts = this.parseFormV2(this.vars.socialInstagramPosts);
    } catch (error) {
      console.warn('Instagram posts not available, using dummy data:', error);
      this.instagram_posts = null;
    }
  },
  mounted() {
    this.onSlideChange();
  },
});
</script>

<style scoped>
.swiper-custom ::v-deep(.swiper-wrapper) {
  align-items: center;
}

iframe {
  width: 100% !important;
  max-width: 100% !important;
  margin: 10px 0 10px 0;
}

.left-arrow,
.right-arrow {
  position: absolute;
}

.left-arrow {
  left: 10px;
  z-index: 10;
}

.right-arrow {
  right: 10px;
  z-index: 10;
}

.left-arrow svg path,
.right-arrow svg path {
  transition: all 0.3s;
}

.left-arrow:hover,
.right-arrow:hover {
  cursor: pointer;
}

.left-arrow:hover svg path,
.right-arrow:hover svg path {
  stroke: var(--c-primary);
}

::-webkit-scrollbar {
  width: 2px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: var(--c-primary);
}
::-webkit-scrollbar-thumb:window-inactive {
  display: none;
}

@media (min-width: 1080px) {
  .left-arrow,
  .right-arrow {
    position: relative;
  }

  .left-arrow {
    padding-right: 18px;
  }

  .right-arrow {
    padding-left: 18px;
  }
}

@media (min-width: 700px) and (max-width: 1400px) {
  ::v-deep(.pm-modal-wrapper) {
    width: 95% !important;
  }
}

@media (min-width: 1401px) {
  ::v-deep(.pm-modal-wrapper) {
    width: 60% !important;
  }
}
</style>
